/**
 * localStorage when the browser (or test runtime) really has one, else an in-memory stand-in. Reading
 * `localStorage` can throw or be missing (Safari private mode, a server-side runtime), and a staff app
 * that cannot remember a venue choice should still run.
 */
const memory = new Map<string, string>()
import { storageKey } from './runtime'

function usable(): Storage | null {
  try {
    const s = (globalThis as { localStorage?: Storage }).localStorage
    if (!s || typeof s.getItem !== 'function') return null
    const probe = '__bookings_probe__'
    s.setItem(probe, '1')
    s.removeItem(probe)
    return s
  } catch {
    return null
  }
}

export const safeStorage = {
  getItem(key: string): string | null {
    key = storageKey(key)
    const s = usable()
    if (s) return s.getItem(key)
    return memory.get(key) ?? null
  },
  setItem(key: string, value: string): void {
    key = storageKey(key)
    const s = usable()
    if (s) s.setItem(key, value)
    else memory.set(key, value)
  },
  removeItem(key: string): void {
    key = storageKey(key)
    const s = usable()
    if (s) s.removeItem(key)
    else memory.delete(key)
  },
}
